<script>
	import Waiting from '../Waiting.svelte';

	export let title;
	export let text;
</script>

<div>
	<div
		class="fixed inset-0 z-50 overflow-y-auto overscroll-none"
		aria-labelledby="modal-title"
		role="dialog"
		aria-modal="true">
		<div class="flex min-h-screen items-center justify-center px-4 pb-20 pt-4 text-center sm:p-10">
			<div class="fixed inset-0">
				<div class="absolute inset-0 bg-gray-500 opacity-75" />
			</div>
			<div
				class="transform overflow-hidden rounded-lg bg-white px-4 pb-4
		pt-5 shadow-xl transition-all sm:w-full sm:max-w-sm sm:p-6 md:max-w-2xl"
				role="dialog"
				aria-modal="true"
				aria-labelledby="modal-headline">
				<div>
					<div class="mx-auto flex items-center justify-center">
						<Waiting />
					</div>
					<div class="mt-3 text-center sm:mt-5">
						<h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-headline">
							{title}
						</h3>
						<div class="mt-2">
							<p class="text-sm leading-5 text-gray-500">{@html text}</p>
						</div>
						<div class="mt-8">
							<slot />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
